import React from "react";
import { Link } from "react-router-dom";
import "./ErrorPage.css";

const ErrorPage = ({ error, resetError }) => {
  const handleRefresh = () => {
    resetError();
    window.location.reload();
  };

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-icon">⚠️</div>
        <h1 className="error-title">متأسفیم، مشکلی پیش آمده است</h1>
        <p className="error-message">
          خطایی در بارگذاری این صفحه رخ داده است. لطفاً بعداً دوباره امتحان
          کنید.
        </p>
        {error && (
          <div className="error-details">
            <p className="error-code">خطا: {error.toString()}</p>
          </div>
        )}
        <div className="error-actions">
          <button onClick={handleRefresh} className="error-retry-button">
            تلاش مجدد
          </button>
          <Link to="/" className="error-home-button">
            بازگشت به صفحه اصلی
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
